// extracted by mini-css-extract-plugin
module.exports = {"banner":"deposit_banner__Ki6bw","bannerEmoji":"deposit_bannerEmoji__R88Nn"};